import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class OverlayDialogService {
  private dialog: MatDialog = inject(MatDialog);

  open<T>(component: ComponentType<T>, config?: MatDialogConfig): MatDialogRef<T> {
    const defaultConfig: MatDialogConfig = {
      height: '100%',
      width: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      panelClass: 'full-screen-dialog',
      disableClose: true,
      ...config
    };

    return this.dialog.open(component, defaultConfig);
  }

  close<T>(ref: MatDialogRef<T>): void {
    ref.close();
  }

  closeAll(): void {
    this.dialog.closeAll();
  }
}
